import { memo, Suspense } from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material';
import Footer from '../footer';


const StyledBox = styled(Box)(({ theme }) => ({
    transition: '0.3s ease-in-out',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: "#F1F1F1",
    minHeight: '100vh',
    paddingLeft: "10px",
    paddingRight: "10px",
    [theme.breakpoints.up('md')]: {
        paddingLeft: "40px",
        paddingRight: "40px",
    }
}));

const StyledChildBox = styled(Box)(({ theme }) => ({
    flexDirection: "column",
    display: "flex",
    gap: "20px",
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
        paddingTop: "40px",
        paddingBottom: "40px",
        gap: "30px",
    }
}));

const NormalChildLayout = memo(({ parentSx, childSx, ...props }) => {
    return (
        <StyledBox key="layout" sx={parentSx} >
            <StyledChildBox sx={childSx}>
                <Suspense fallback={null}>
                    <Outlet />
                </Suspense>
            </StyledChildBox>
            {!parentSx && <Footer key="footer" />}
        </StyledBox>
    );
});

export default NormalChildLayout;